import React from 'react';

import AdminConponent from '../../components/Admin';

// Importando CSS
import '../../styles/global.css';
import './style.css';

function Admin() {

    return (
        <AdminConponent />
    );
}

export default Admin;